import { Constants } from '@pwc/pwc-deals-web-common';

const getLibraryItemTypeDisplayName = (libraryItemTypeValue) =>
  Object.values(Constants.LIBRARY_ITEM_TYPES).find(
    (type) => type.value === libraryItemTypeValue
  ).displayName;

export default getLibraryItemTypeDisplayName;
